import React from 'react';
import '../styles/Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>&copy; 2025 Medo Design Co. All rights reserved.</p>
  </footer>
);
export default Footer;